import { Base_Url } from "../../BaseUrl/BaseUrl";
import { getApiWithoutAuthorization, postApiWithoutAuthorization } from "../ApiMethods/ApiMethods";
import axios from "axios";

export const website_inquiry = async (apiParam) => {
    const res = await postApiWithoutAuthorization(`${Base_Url}/website-inquiry`, apiParam);
    return res;
};

export const school_inquiry = async (apiParam) => {
    const res = await postApiWithoutAuthorization(`${Base_Url}/school-inquiry`, apiParam);
    return res;
};
export const Employee_enquiry = async (apiParam) => {
    const res = await postApiWithoutAuthorization(
        `${Base_Url}/employer-inquiry`,
        apiParam
    );
    return res;
};

export const unsubscribe = async (token) => {
    try {

        const res = await getApiWithoutAuthorization(`${Base_Url}/unsubscribe/${token}`);
        return res;
    } catch (error) {
        throw error; // Let the calling component handle the error
    }
};

export const get_public_job_lead = async ({ id, token }) => {
    try {
        const endpoint = id
            ? `${Base_Url}/public/job-lead`
            : `${Base_Url}/public/job-lead/${encodeURIComponent(token)}`;
        const response = await axios.get(endpoint, {
            ...(id ? { params: { id } } : {}),
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
